import React from 'react'
import PropTypes from 'prop-types'

const HiddenInput = (props) => {

  return <input type="hidden" {...props.input} />
};

HiddenInput.propTypes = {
  input: PropTypes.object,
  name: PropTypes.string,
  options: PropTypes.object,
  resource: PropTypes.string,
  source: PropTypes.string,
  type: PropTypes.string,
  validators: PropTypes.arrayOf(PropTypes.func),
};

HiddenInput.defaultProps = {
  addField: true,
  options: {},
  validators: [],
};

export default HiddenInput;


// WEBPACK FOOTER //
// ./src/components/input/HiddenInput.js